import { IImage, IProductWithAttributes } from '@gn-audio/core/api/product-catalogue/models';
import { isObject, isString } from 'angular';

import {
  FamilyCustomizerController,
  IFamilyCustomizerScope,
  IFamilyCustomizerScopeConfiguration,
} from '../family-customizer-spot/family-customizer.controller';
import { IFilter } from '../models';
import { ICustomizerFilterService } from '../services/customizer-filter.service';

interface IHeroCustomizerImage extends IImage {
  isLifestyleImage: boolean;
  selected: boolean;
}

export interface IHeroCustomizerScopeConfiguration extends IFamilyCustomizerScopeConfiguration {
  lifestyleImages: string;
}

/**
 * @deprecated Should be converted into component!
 */
export interface IHeroCustomizerScope extends IFamilyCustomizerScope {
  images: IHeroCustomizerImage[];
  lifestyleImages: IHeroCustomizerImage[];
  selectedImage: IHeroCustomizerImage;
  configuration: IHeroCustomizerScopeConfiguration;

  selectImage(image: IHeroCustomizerImage): void;
  getColorOptionImage(filter: IFilter, value: string): string;
  getFilterDefaultValue(filter: IFilter): string;
  removeSizes(imagesrc: string): string;
}

export class HeroCustomizerController extends FamilyCustomizerController {
  public static $inject: ReadonlyArray<string> = ['$scope', '$location', '$q', 'customizerFilterService'];

  protected filterTemplateSuffix = 'hero-customizer-spot-filter-';

  private defaultFilterValues: object = {};

  constructor(
    protected $scope: IHeroCustomizerScope,
    $location: ng.ILocationService,
    $q: ng.IQService,
    filterService: ICustomizerFilterService,
  ) {
    super($scope, $q, $location, filterService);

    this.$scope.selectImage = (image: IHeroCustomizerImage): void => {
      this.$scope.images.forEach(
        (x: IHeroCustomizerImage): void => {
          x.selected = false;
        },
      );
      this.$scope.lifestyleImages.forEach(
        (x: IHeroCustomizerImage): void => {
          x.selected = false;
        },
      );

      if (!isObject(image) || image === null) {
        return;
      }

      image.selected = true;
      this.$scope.selectedImage = image;
    };

    this.$scope.getColorOptionImage = (filter: IFilter, value: string): string => {
      const originalValue: string = filter.value;

      filter.value = value;
      const filters: IFilter[] = [filter];
      const match: IProductWithAttributes = this.filterService.filter(this.$scope.groups, filters)[0];
      filter.value = originalValue;

      if (match) {
        return match.images[0].url;
      } else {
        return '';
      }
    };

    $scope.removeSizes = (imageSrc: string): string => {
      return (imageSrc || '').replace(/\?(.)*/gi, '');
    };

    this.$scope.getFilterDefaultValue = (filter: IFilter): string => {
      return this.defaultFilterValues[filter.key];
    };

    const lifestyleImagesWatcher: () => void = this.$scope.$watch(
      'configuration.lifestyleImages',
      (): void => {
        const lifestyleImages: any[] = JSON.parse(this.$scope.configuration.lifestyleImages);

        if (lifestyleImages) {
          this.$scope.lifestyleImages = new Array<IHeroCustomizerImage>();
          lifestyleImages.forEach((lifestyleImage: any): void => {
            this.$scope.lifestyleImages.push({
              isLifestyleImage: true,
              selected: false,
              url: lifestyleImage.Src,
            });
          });
        }

        lifestyleImagesWatcher();
      },
    );
  }

  public setImages(product: IProductWithAttributes): void {
    this.$scope.images = product.images
      .filter((image: IImage): boolean => isObject(image) && isString(image.url) && image.url !== '')
      .filter((image: IImage): boolean => image.url.match(/.(jpg|jpeg|png|tiff|tif)/gi) !== null)
      .map(
        (image: IImage): IHeroCustomizerImage => {
          return {
            isLifestyleImage: false,
            selected: false,
            url: image.url,
          } as IHeroCustomizerImage;
        },
      );
  }

  public filter(): void {
    super.filter();
    this.setImages(this.$scope.selection);
    this.$scope.selectImage(this.$scope.images[0]);
  }

  protected onFamilyGroupsPrepared(groups: IProductWithAttributes[]): void {
    super.onFamilyGroupsPrepared(groups);
    this.setImages(this.$scope.selection);
    this.$scope.selectImage(this.$scope.images[0]);
    this.$scope.filters.forEach(
      (filter: IFilter): void => {
        this.defaultFilterValues[filter.key] = filter.value;
      },
    );
  }
}
